import { PlayerEvent } from 'bitmovin-player';
export function removeReplayClass(player) {
    if (!player)
        return;
    player.off(PlayerEvent.Seek, () => {
        removeReplayClass(player);
    });
    const playerContainer = player.getContainer().querySelector('.bmpui-npo-player');
    playerContainer?.classList.remove('bmpui-player-state-finished');
    playerContainer?.classList.remove('bmpui-player-state-replay');
    playerContainer?.classList.add('bmpui-player-state-paused');
}
